import { useMutation } from '@apollo/client';
import { useSnackbar } from '@components/Snackbar/SnackbarProvider';
import { UPDATE_FEATURE_UPERCUT } from '@gql/subscriptions';
import { useCallback } from 'react';
import { Feature } from '../types';


interface UpdateFeatureCallbacks {
    onSuccess?: () => void;
    onError?: () => void;
}

export const useFeatureUpdate = () => {
    const [updateFeatureMutation, { loading }] = useMutation(UPDATE_FEATURE_UPERCUT);
    const { showSnackbar } = useSnackbar();

    const updateFeature = useCallback(
        async (
            featureId: string,
            newConfiguration: Feature['configuration'],
            callbacks?: UpdateFeatureCallbacks,
            reason?: string,
        ): Promise<boolean> => {
            try {
                await updateFeatureMutation({
                    variables: {
                        _id: featureId,
                        payload: {
                            configuration: newConfiguration,
                        },
                        reason: reason || '',
                    },
                });

                showSnackbar('Fonctionnalité mise à jour avec succès.', 'success');
                callbacks?.onSuccess?.();
                return true;
            } catch (error) {
                showSnackbar((error as Error)?.message || 'Échec de la mise à jour.', 'error');
                callbacks?.onError?.();
                return false;
            }
        },
        [showSnackbar, updateFeatureMutation],
    );

    return { updateFeature, loading };
};
